import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_LegalClientHeadController_SaveStatus_Input_Status,
  useLegalClientBranchSaveStatusMutation,
} from 'api/generated/graphql';
import { parseLegalClientBranchEntity, useError } from 'api/helpers';

interface Props {
  versionNumber: number;
  reason: string;
}

export const useLegalClientBranchArchive = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientBranchSaveStatusMutation();

  const error = useError(apolloError);

  return {
    legalClientBranch: data?.saveStatus
      ? parseLegalClientBranchEntity(data.saveStatus)
      : undefined,
    loading,
    error,
    archive: useCallback(
      async (id: string, { reason, versionNumber }: Props) => {
        const res = await handle({
          variables: {
            id,
            input: {
              reason,
              versionNumber,
              status:
                MutationInput_LegalClientHeadController_SaveStatus_Input_Status.Archived,
            },
          },
        });
        return res.data?.saveStatus
          ? parseLegalClientBranchEntity(res.data?.saveStatus)
          : undefined;
      },
      [handle]
    ),
  };
};
